export const common = {
  scrollToTop: "Remonter en haut de la page",
  pagination: {
    totalItems: 'Total des éléments',
    previous: 'Précédent',
    next: 'Suivant',
    page: 'Page',
    showing: 'Affichage de',
    to: 'à',
    of: 'sur',
    items: 'éléments'
  },
  actions: {
    edit: 'Modifier',
    delete: 'Supprimer',
    expand: 'Développer',
    collapse: 'Réduire',
    save: 'Enregistrer',
    cancel: 'Annuler',
    confirm: 'Confirmer',
    close: 'Fermer',
    print: 'Imprimer',
    export: 'Exporter',
    add: 'Ajouter',
    title: 'Actions'
  },
  status: {
    active: 'Actif',
    inactive: 'Inactif'
  },
  loading: 'Chargement...',
  noData: 'Aucune donnée disponible',
  filters: {
    sort: {
      label: 'Trier par',
      placeholder: 'Sélectionner un champ',
      directions: {
        asc: 'Croissant',
        desc: 'Décroissant'
      }
    }
  }
}; 